import { useEffect, useState } from "react";
import spinner from "../assets/spinner2.gif";
import Slider from "../components/Slider";
// import Footer from "../components/Footer";
import dayjs from "dayjs";
import DefaultMenu from "../components/DetailsMenu";
import AlertBar from "../components/AlertBar";
import MagnifyGlass from "../assets/magnify-glass.png";
import EditSwatch from "../components/EditSwatch";
import { useNavigate, useParams } from "react-router-dom";
import { useGetFilterAutofillData } from "../hooks/useGetFilterAutofillData";
import { useGetSwatch } from "../hooks/useGetSwatch";
import GroupDisplay from "../components/GroupDisplay";
import { initialState } from "./SwatchesPage/Swatches";

export default function SwatchDetails() {
  const urlParams = new URLSearchParams(window.location.search);
  const isEditMode = urlParams.get("mode") === "edit";
  const { data: filterAutofIllData } = useGetFilterAutofillData(true);

  const { swatchId: uniqueCode } = useParams();
  const {
    data: swatchData,
    isLoading: isSwatchloading,
    refetch,
  } = useGetSwatch(uniqueCode);
  const [isLoading, setIsLoading] = useState(true);
  const [showDetails, setShowDetails] = useState(false);
  const [currentImageUrl, setCurrentImageUrl] = useState("");

  const [additionalImagesData, setAdditionalImagesData] = useState({
    isSelected: false,
    idx: "",
  });

  const [Alert, setAlert] = useState({
    show: false,
    msg: "",
  });
  const navigate = useNavigate()


  const collection = swatchData?.data || [];
  const imageIndex = collection.findIndex(
    (item) => item.unique_code === uniqueCode
  );

  useEffect(() => {
    document.title = uniqueCode;
  }, [uniqueCode])

  if (isSwatchloading) {
    return (
      <div className="loading">
        <img src={spinner} alt="Loading..." />
      </div>
    );
  }

  if (imageIndex === -1) {
    return <div>Swatch not found</div>;
  }

  let swatch = collection[imageIndex];

  const handelCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ show: false, msg: "" });
  };


  const formatDate = (date) => {
    if (dayjs(date, "YYYY-MM-DD HH:mm:ss").isValid()) {
      return dayjs(date, "YYYY-MM-DD HH:mm:ss").format("MMM DD, YYYY");
    } else {
      return date;
    }
  };

  const attributesDetails = [
    { key: "Basic Fabric", value: swatch.basic_fabric },
    { key: "Hand", value: swatch.hand },
    { key: "Color", value: swatch.color },
    { key: "Material", value: swatch.material },
    { key: "Artwork", value: swatch.artwork },
    { key: "Effect", value: swatch.effect },
    { key: "Techniques", value: swatch.techniques },
    { key: "Era", value: swatch.era },
  ];

  const otherDetails = [
    {
      key:
        swatch.handed_over_to_client ||
        swatch.handed_over_to_an_employee_for_internal_use ||
        swatch.handed_over_to_an_employee_for_showcasing
          ? "In possession of"
          : "Location",
      value: swatch.location_person,
    },
    {
      key: "Part of a shared collection?",
      value: swatch.part_of_a_shared_collection ? "Yes" : "No",
    },
    { key: "Box Classification", value: swatch?.cdata?.box_classification },
    {
      key: "Expected Return Date",
      value: formatDate(swatch.expected_return_date),
    },
    { key: "Box Number", value: swatch?.cdata?.box_number },
    { key: "Cannot Share Till", value: formatDate(swatch.cannot_share_till) },
    { key: "Year Of Creation", value: swatch.year_of_creation },
    { key: "Manhours", value: swatch?.cdata?.manhours },
  ];

  const openInNewTab = (url) => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    } else if (swatch?.cdata?.primary_image) {
      window.open(
        swatch.cdata.primary_image.replace("w_1100,", ""),
        "_blank",
        "noopener,noreferrer"
      );
    }
  };

  return (
    <>
      <div className="swatch-page-container">
        <div
          className={"swatch-page-wrapper " + (isEditMode ? "edit-mode" : "")}
        >
          <div>
            <div
              style={{ textAlign: "center" }}
              className="collection-code-container collection-code-2"
            >
              <div className="heading-and-zoom-section">
                <strong
                  onClick={() => setShowDetails(!showDetails)}
                  className="swatch-code"
                >
                  Swatch Code: {uniqueCode}
                </strong>
                <img
                  alt="zoom icon"
                  onClick={() =>
                    openInNewTab(currentImageUrl.replace("w_1100,", ""))
                  }
                  className="zoom-icon"
                  src={MagnifyGlass}
                ></img>
              </div>
              <>
              <GroupDisplay filterAutofIllData={filterAutofIllData} tag={swatch?.cdata?.tag}  onClick={(tagObject) =>   {
                console.log(tagObject)
                  if (tagObject){
                    const urlParams = new URLSearchParams(window.location.search);
                    navigate("/Swatches?" + urlParams.toString(), {
                      state: { filters: {...initialState,  Status: "",
                        attributes: [tagObject]
                      } },
                    });
                    
                  }
                  }} />
              </>
              {additionalImagesData.isSelected ? (
                <div style={{ position: "relative" }}>
                  <DefaultMenu
                    deleteAdditionalImageFromState={refetch}
                    setAlert={setAlert}
                    uniqueCode={uniqueCode}
                    idx={additionalImagesData.idx}
                  />
                </div>
              ) : null}
            </div>
            {isLoading && (
              <div className="loading">
                <img src={spinner} alt="Loading..." />
              </div>
            )}
            <div>
              <Slider
                key={swatch.unique_code}
                primary_image={swatch.cdata.primary_image}
                additional_images={swatch.cdata.additional_images}
                setIsLoading={setIsLoading}
                url={[swatch]}
                isLoading={isLoading}
                setAdditionalImagesData={setAdditionalImagesData}
                setCurrentImageUrl={setCurrentImageUrl}
              />
            </div>
            {showDetails ? (
              <div className="swatches-details-wrapper">
                <div className="swatches-details-container">
                  <div>
                    <div className="details-section">
                      <h4 className="details-subheading">Attributes</h4>
                      <div className="details-section-content-container">
                        {attributesDetails.map((item) => {
                          return (
                            <div key={item.key} class="index-row">
                              <div class="index-rowKey">{item.key}</div>
                              <div class="index-rowValue">
                                {item.value
                                  ? item.value.split(",").join(", ")
                                  : "-"}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    <div className="details-section">
                      <h4 className="details-subheading">Other Details</h4>
                      <div className="details-section-content-container">
                        {otherDetails.map((item) => {
                          return (
                            <div key={item.key} class="index-row">
                              <div class="index-rowKey">{item.key}</div>
                              <div class="index-rowValue">
                                {item.value ? item.value : "-"}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    {swatch?.cdata?.description ? (
                      <div className="details-section">
                        <h4 className="details-subheading">Description</h4>
                        <div className="details-section-content-container">
                          <p className="details-description">
                            {swatch?.cdata?.description}
                          </p>
                        </div>
                      </div>
                    ) : null}
                    {swatch?.cdata?.sold_remarks ? (
                      <div className="details-section">
                        <h4 className="details-subheading">Remarks (Added while marking as sold)</h4>
                        <div className="details-section-content-container">
                          <p className="details-description">
                            {swatch?.cdata?.sold_remarks}
                          </p>
                        </div>
                      </div>
                    ) : null}
                    {swatch.artist ? (
                      <div className="artist-container">
                        <h4
                          style={{ paddingBottom: 0 }}
                          className="details-subheading"
                        >
                          Designer:{" "}
                        </h4>
                        <div>
                          <p>{swatch.artist}</p>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          {isEditMode && swatch ? (
            <div>
              <EditSwatch
                refetch={refetch}
                setIsLoading={setIsLoading}
                filterAutofIllData={filterAutofIllData}
                swatchDetails={swatch}
              />
            </div>
          ) : null}
        </div>
        <AlertBar
          showAlert={Alert.show}
          handelCloseAlert={handelCloseAlert}
          AlertMessage={Alert.msg}
        />
      </div>
    </>
  );
}
